import './JiraSelectedProjects.scss';
import { JiraStatusMapping } from './JiraStatusMapping';
import { jiraSummarySelectors } from './@arch/selectors';
import React from 'react';
import { useSonarSelector } from '@hooks';
import { When } from 'react-if';

export const JiraSelectedProjects: React.FC = () => {
	const jiraSummary = useSonarSelector(jiraSummarySelectors.data);

	return (
		<div className='jira-selected-projects'>
			{
				jiraSummary?.selectedProjects?.map(
					({ projectKey, projectName, issueTypes }) =>
						<div
							className='jira-project'
							key={ projectKey }>
							<When condition={ jiraSummary?.selectedProjects.length !== 1 }>
								<div className='h3'>{ projectName }</div>
							</When>
							{
								issueTypes?.map(
									({ issueTypeId, issueTypeName, statuses }) =>
										<div
											className='jira-issue'
											key={ issueTypeId }>
											<div className='h3'>{ issueTypeName }</div>
											<div className='status-mappings'>
												{
													statuses?.map(
														(status) => <JiraStatusMapping
															key={ status.jiraStatusId }
															status={ status } />
													)
												}
											</div>
										</div>

								)
							}
						</div>
				)
			}
		</div>
	);
};
